import { mutationOptions } from '@tanstack/react-query'
import getApiResponseData from '@utils/get-api-response-data'

import { api } from '../api/api'
import { type RequestApi } from '../api/types'
import { key } from './key'

type EditRequestParams = {
  id: string
  request: RequestApi.EditRequest
}

export const editRequestMutation = () =>
  mutationOptions({
    mutationKey: key('edit-request'),
    mutationFn: async ({ id, request }: EditRequestParams) => {
      const { data } = await api.edit(id, request)
      const result = getApiResponseData(data)

      if (!result?.request) {
        throw new Error('fulfillment request edit returned no request')
      }

      return result
    },
    retry: false,
  })
